import {Component} from "@angular/core";
import {AuthService} from "../../services/auth/auth.service";
import {environment} from "../../../environments/environment";
import {MenuService} from "../../services/menu.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {APIService} from "../../services/api.service";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    animations: [
        trigger("smoothCollapse", [
            state("initial", style({
                height: "0",
                overflow: "hidden",
                opacity: "0"
            })),
            state("final", style({
                overflow: "hidden",
                opacity: "1"
            })),
            transition("initial=>final", animate("0.3s")),
            transition("final=>initial", animate("0.3s"))
        ]),
    ]
})
export class HeaderComponent {

    constructor(
        public menuService: MenuService,
        public authService: AuthService,
    ) {
    }

    isMenuOpen = false;
    public title = environment.appTitle;
    // tslint:disable-next-line:variable-name
    _isSubmenuCollapsed: any = {};
    // tslint:disable-next-line:variable-name
    _isItemsCollapsed: any = {};

    isCollapsed(code, isMenu) {
        const item = isMenu ? this._isSubmenuCollapsed[code] : this._isItemsCollapsed[code];

        return item === undefined ? true : item;
    }

    collapse(isMenu) {
        const items = isMenu ? this._isSubmenuCollapsed : this._isItemsCollapsed;
        for (const key in items) {
            if (Object.prototype.hasOwnProperty.call(items, key)) {
                items[key] = true;
            }
        }
    }

    toggle(code, isMenu, callPage) {
        const newState = !this.isCollapsed(code, isMenu);

        this.collapse(isMenu);
        if (isMenu) {
            this._isSubmenuCollapsed[code] = newState;
        } else {
            this._isItemsCollapsed[code] = newState;
        }

        if (callPage) {
            this.ToggleMenu();
        }

    }

    ToggleMenu() {
        this.menuService.setMenuStatus(!this.menuService.menuStatus);
    }
}
